import(/* webpackMode: "eager" */ "/home/ubuntu/download/69bdb0627d947e0014e91ad5/mint_1774039138141/src/app/contact/page.tsx");
